<section class="streamin-widget-wrap" id="streaminWidgetWrap">
    <div id="fullWidget" class="lmt-container"></div>
    <div id="stickyWidget" class="lmt-container-sticky"></div>
</section>

<script>
    // SRConfig = {
    //     // jezik
    //     client: {
    //         language: 'srl'
    //     },
    //     on: {
    //         srlive_initialized: function () {
    //             SRLive.addWidget({
    //                 name: 'widgets.lmts',
    //                 config: {
    //                     container: '.lmt-container',
    //                     showTitle: false,
    //                     matchId: 21999215,
    //                     showMomentum: false,
    //                     pitchCrowd: true, // teren
    //                     showGoalscorers: false,
    //                     showMomentum2: false,
    //                     showScoreboard: false,
    //                     sidebarLayout: 'dynamic', // statistika (bottom)  'statick'
    //                     showSidebar: false, // statistika
    //                     collapse_enabled: false
    //                 },
    //                 callback: function () {
    //                    alert('Widget ucitan!');
    //                 }
    //             });

    //             // SRLive.addWidget({
    //             //     name: 'widgets.matchcommentary',
    //             //     config: {
    //             //         container: '.widgetRightContainer1',
    //             //         showTitle: false,
    //             //         matchId: 21997833,
    //             //         height: '100%'
    //             //     },
    //             // });
    //         }
    //     }
    // };

    // (function (d, s, id) {
    //     var js, h = d.getElementsByTagName(s)[0];
    //     if (d.getElementById(id)) {
    //         return;
    //     }
    //     js = d.createElement(s);
    //     js.id = id;
    //     js.async = true;
    //     js.setAttribute("data-autoInit", true);
    //     js.setAttribute("data-matchId", 0);
    //     js.src = 'https://cs.betradar.com/ls/widgets/?/millenniumbetserbia/en/Europe:Berlin/widgetloader/widgets/whitelabel1';
    //     h.parentNode.insertBefore(js, h);
    // }(document, 'script', 'sr-wl'));
</script>